import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";
import Work4 from "../../assets/work4.png";
import Work5 from "../../assets/work5.png";

export const projectsData = [
  {
    id: 1,
    image: Work1,
    title: "Mytheresa",
    description:
      "Mytheresa is a German e-commerce luxury fashion company. Founded in 2006.",
    githubLink: "https://github.com/paprisaha1999/purring-recess-1554",
    netlifyLink: "https://superlative-lily-39163c.netlify.app/",
    techStack: "HTML | CSS | JavaScript",
  },
  {
    id: 2,
    image: Work2,
    title: "Airtable",
    description:
      "Airtable is a cloud collaboration service. It was founded in 2012.",
    githubLink: "https://github.com/paprisaha1999/puzzlingTheadT4770",
    netlifyLink: "https://airtableappbypapri.netlify.app",
    techStack: "HTML | CSS | JavaScript | React",
  },
  {
    id: 3,
    image: Work3,
    title: "Suger Cosmetics",
    description:
      "SUGAR Cosmetics is an Indian e-commerce company. Founded in 2015.",
    githubLink: "https://github.com/RiteshAravindra/mean-design-4445",
    netlifyLink: "https://jade-otter-79c1e4.netlify.app/",
    techStack: "HTML | CSS | JavaScript",
  },
  {
    id: 4,
    image: Work4,
    title: "ZoomCar",
    description:
      "Zoomcar is an Indian car sharing platform, headquartered in Bangalore. It operate in Self Driving Car Rentals.",
    githubLink: "https://github.com/Suneet25/zoomcar-clone",
    netlifyLink: "https://sick-insect-8581.vercel.app/",
    techStack: "HTML | JavaScript | React | Redux | Chakra-UI",
  },
  {
    id: 4,
    image: Work5,
    title: "Lenskart",
    description:
      "Lenskart is an Indian multinational optical prescription eyewear retail chain. Founded in 2010.",
    githubLink: "https://github.com/akashfulari18/thoughtless-scarecrow-7735",
    netlifyLink: "https://thoughtless-scarecrow-7735-akashfulari18.vercel.app/",
    techStack: "HTML | JavaScript | React | Redux | Chakra-UI",
  },
];
